var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnedActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Returned_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Returned_Active",
    clipPath: "url(#clip-Returned_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9894",
    "data-name": "Group 9894",
    transform: "translate(-621 -213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857",
    transform: "translate(622 214)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9895",
    "data-name": "Group 9895",
    transform: "translate(11.469 12.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19442",
    "data-name": "Path 19442",
    d: "M0,6.275,6.547,0l6.691,6.275",
    transform: "translate(0 13.238) rotate(-90)",
    fill: "none",
    stroke: "#58697c",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19444",
    "data-name": "Path 19444",
    d: "M5068.193-6882.6h14.765",
    transform: "translate(-5067.896 6889.432)",
    fill: "none",
    stroke: "#58697c",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnedActive);
export default __webpack_public_path__ + "static/media/Returned_Active.80f1691263faa61523b82fa6b21a607e.svg";
export { ForwardRef as ReactComponent };